module.exports = __webpack_public_path__ + "img/cementera.7ccbd7e8.png";